module.exports = __webpack_public_path__ + "assets/812a945cc44652f0e2d36ead34915701.svg";